import { render, staticRenderFns } from "./UpdateTing.vue?vue&type=template&id=142ad8aa"
import script from "./UpdateTing.vue?vue&type=script&lang=js"
export * from "./UpdateTing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports